import { render, staticRenderFns } from "./EditProductPermission.vue?vue&type=template&id=82022fe4"
import script from "./EditProductPermission.vue?vue&type=script&lang=js"
export * from "./EditProductPermission.vue?vue&type=script&lang=js"
import style0 from "./EditProductPermission.vue?vue&type=style&index=0&id=82022fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports